import { useMap } from "react-map-gl/mapbox";
import { useEffect } from "react";
import { useMapContext } from "../contexts/MapContext";
import { LngLatBounds } from "mapbox-gl";
import { useBreakpointValue } from "@gemini/core";
import { DEFAULT_ZOOM } from "@/domains/map/constants";
export const useEventHandler = () => {
    const { current: map } = useMap();
    const { viewport, destination, travelTimes } = useMapContext();
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    useEffect(() => {
        const paddingValues = isMobile
            ? { top: 150, bottom: 300, left: 50, right: 50 }
            : { top: 250, bottom: 250, left: 250, right: 250 };
        const bounds = new LngLatBounds(viewport.bounds.getSouthWest(), viewport.bounds.getNorthEast());
        if (destination && (travelTimes === null || travelTimes === void 0 ? void 0 : travelTimes.length) > 0) {
            bounds.extend([destination.coordinates.lng, destination.coordinates.lat]);
            map === null || map === void 0 ? void 0 : map.fitBounds(bounds, {
                padding: paddingValues,
            });
        }
        else {
            map === null || map === void 0 ? void 0 : map.easeTo({
                center: viewport.center,
                zoom: DEFAULT_ZOOM,
                duration: 2000,
            });
        }
    }, [
        destination,
        map,
        travelTimes,
        viewport.bounds,
        isMobile,
        viewport.center,
    ]);
    return null;
};
